export default __webpack_public_path__ + "static/consumer-awards-tabby-2018-9c07e61959d55f505363a6eff34d9b58.png";